import React from 'react'
import Root from './Root'
export default ()=>(
    <Root />
)